import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LocalEstoque } from '../classes/LocalEstoque';

@Injectable({
  providedIn: 'root'
})
export class LocalEstoqueService {

  constructor(private http: HttpClient) { }

  getLocaisEstoque(): Observable<any>{
    return this.http.get(`${environment.apiURL}/localEstoque`)
  }

  getTodosGrupoEquipamentos(): Observable<any>{
    return this.http.get(`${environment.apiURL}/localEstoque/ListarTodos`)
  }

  getLocalEstoque(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/localEstoque/${id}`)
  }

  postLocalEstoque(localEstoque: LocalEstoque): Observable<any>{
    return this.http.post(`${environment.apiURL}/localEstoque`, localEstoque);
  }

  putLocalEstoque(id: number, localEstoque: LocalEstoque): Observable<any>{
    return this.http.put(`${environment.apiURL}/localEstoque/${id}`, localEstoque);
  }

  deleteLocalEstoque(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/localEstoque/${id}`);
  }

  listarPorFazenda(fazendaId: number): Observable<any>{
    return this.http.get(`${environment.apiURL}/localEstoque/fazenda/${fazendaId}`)
  }

  deleteLista(ids: number[]): Observable<any>{
    const params = ids.map(id => `ids=${id}`).join('&');
    return this.http.delete(`${environment.apiURL}/localEstoque/Deletar?${params}`, );
  }

  duplicar(ids: number[]): Observable<any>{
    return this.http.post(`${environment.apiURL}/localEstoque/duplicar`, ids);
  }
  inativar(ids: number[]): Observable<any>{
    return this.http.put(`${environment.apiURL}/localEstoque/inativar`, ids);
  }

  formatarData(data: Date): string {
    var year = data.getFullYear().toString();
    var month = (data.getMonth() + 1).toString().padStart(2, '0');
    var day = data.getDate().toString().padStart(2, '0');
    return year + "-" + month + "-" + day;
  }

  public toQueryString(obj: any): string {
    const parts = [];
    for (const key in obj) {
      if (obj.hasOwnProperty(key) && obj[key]) {
        if (obj[key] instanceof Date) {
          const dateStr = this.formatarData(obj[key]);
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(dateStr)}`);
        } else {
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
        }
      }
    }
    return parts.join('&');
  }
}
